import { createSlice } from '@reduxjs/toolkit';

const userSlice = createSlice({
  name: 'user',
  initialState: {
    profile: null,
    emailPreferences: null,
    isLoading: false,
    error: null,
  },
  reducers: {
    setUserProfile(state, action) {
      state.profile = action.payload;
      state.isLoading = false;
      state.error = null;
    },
    resetUser(state) {
      state.profile = null;
      state.emailPreferences = null;
      state.isLoading = false;
      state.error = null;
    },
  },
});

export const { setUserProfile, resetUser } = userSlice.actions;
export default userSlice.reducer;
